<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZExP99/tc-custom/9780062796776.jpg?1732167262836" alt="This image is the cover for the book That's What She Said"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">That's What She Said
      </h1>
      <p class="bookDescription body article font2">
        <p>An artist and activist committed to the empowerment of women and girls has created a gorgeous illustrated volume, blending watercolor and short biography to showcase the contributions of more than fifty influential female leaders whose words and actions are a passionate call to arms.</p><p>Distraught by the results of the 2016 election and the realization that the nation was not ready for its first female president, Kimothy Joy found herself poring over the biographies of brave women throughout history—those who persisted in the face of daunting circumstances—to learn from their experiences.</p><p>Turning to art, Joy channeled her feelings to the canvas, bringing these strong women to life in bold watercolor portraits surrounded by inspirational hand-lettered quotes. With each creation, Joy found catharsis and hope. She shared her watercolors with her online community and encouraged everyone to raise their own voices and recharge for the battles ahead.</p><p>Now, in this beautiful gift book, Joy has gathered her stunning illustrations and quotes and paired them with surprising, illuminating biographies of her subjects to inspire women of all ages, races, and backgrounds. <i>That’s What She Said</i> honors a powerful and diverse group of over fifty women—from Maya Angelou, Gloria Steinem, and Virginia Woolf to Sojourner Truth, Malala Yousafzai, and Ruth Bader Ginsburg—role models whose words and insights remind us that we must never give up the fight for a more just and equitable society.</p><p>Reclaiming the derogatory cultural barb "that’s what she said," this stunning book celebrates strong female leadership throughout history and empowers current and future generations to find their voices and inspire change in their communities.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kimothy Joy
      </h2>
      
      <p class="authorDescription body article"><P>Kimothy Joy is a Denver-based artist and social activist whose signature style combines watercolor and ink pen with hand lettering. Her work appeared around the world following the 2017 Women&#8217;s March on Washington, and she has since contributed art to and collaborated with Melinda Gates, I AM THAT GIRL, She&#8217;s The First, Gucci, Juniper Books, author Jessica Bennett, and poets Nikita Gill and Cleo Wade. Her work has also been featured on media platforms such as the <I>Huffington Post</I>; <I>Teen Vogue</I>; <I>Refinery29</I>; <I>Glamour</I>; <I>O, The Oprah Magazine</I>; and many more. Kimothy&#8217;s artwork aims to add a sincere and hopeful message of empowerment to women and girls.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?da4d5c46